const au = (props) => props.children; 

export default au;